const common = {
    'common.sure': '确认',
    'common.save': '保存',
    'common.cancel': '取消',
    'common.loading': '正在加载...',
    'common.loading.noMore': '没有更多了~',
    'common.loading.loading1': '加载中',
    'common.success': '成功',
    'common.fail': '失败',
    'common.unKnowError': '未知异常',
    'common.unitDayOdd': '天',
    'common.unitDayPlural': '天',
    'common.unitMonthOdd': '月',
    'common.unitMonthPlural': '个月',
    'common.infiniteAct': '首月不限量 !',
    'common.label': '促销活动即将到来',
    'common.404': '啊哦~ 你访问的页面不见了'
}
const language = {
    'lang.chinese': '中文',
    'lang.english': '英语',
    'lang.germany': '德语',
    'lang.spanish': '西班牙语',
    'lang.french': '法语',
    'lang.italian': '意大利语',
    'lang.portuguese': '葡萄牙语',
}
// 登录页
const login = {
    'login.loginText': '登录',
    'login.input.email': '邮箱(LenovoID)',
    'login.input.password': '密码',
    'login.tip.noAccount': '还没有账号？',
    'login.tip.toRegister': '前往注册',
    'login.tip.forget': '忘记密码',
    'login.check.noInfo': '邮箱或密码错误',
    'login.failed': '登录失败',
    'login.terms': '请勾选阅读条款',
    'login.banner.flow': 'Offerta imperdibile! Registrati ora e goditi 1GB di dati gratuiti per 6 mesi*',
    'login.banner.VFflow': 'Offerta imperdibile! Registrati ora e goditi 5GB di dati gratuiti per 3 mesi*',
    'login.banner.coming': 'con una sorpresa per il primo mese:',
    'login.banner.size': 'dati illimitati!'
}
// 注册页面
const register = {
    'register.registerText': '注册',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': '邮箱',
    'register.input.imgCode': '图片验证码',
    'register.input.verifyCode': '验证码',
    'register.input.password': '密码',
    'register.input.rePassword': '确认密码',
    'register.input.alRegister': '已经注册',
    'register.input.toLogin': '去登录',
    'register.input.termsOfService': '使用条款',
    'register.input.privacyStatement': '隐私声明',
    'register.tip': '创建帐户即表示您同意{termsOfService}和{privacyStatement}。',
    'register.tipForTablet': '创建账户即表示我已阅读并同意<a1>套餐说明</a1>, 懂的通信的<a2>使用条款</a2> 、 HUE的<a3>使用条款</a3>、 懂的通信的<a4>隐私政策</a4>, HUE的<a5>隐私政策</a5>。',
    'register.sendMsg.text': '获取验证码',
    'register.sendMsg.reSend': '重新发送',
    'register.sendMsg.sendSuccess': '发送成功',
    'register.sendMsg.sendFailed': '发送失败',
    'register.check.noEmailField': '请输入邮箱',
    'register.check.noImageCodeField': '请输入图片验证码',
    'register.check.noVerifyField': '请输入邮箱验证码',
    'register.check.noPasswdField': '请输入密码',
    'register.check.noConfirmPasswd': '请确认密码',
    'register.check.errorEmail': '邮箱错误',
    'register.check.errorImageCode': '图片验证码错误',
    'register.check.errorVerifyCode': '验证码错误',
    'register.check.errorPasswd': '密码错误',
    'register.check.errorTwoPasswd': '两次密码不一致',
    'register.success': '注册成功',
}
// 首页
const home = {
    'home.header.upload': '上传',
    'home.header.iccid': 'iccid 码',
    'home.flowUse.title': '当前套餐',
    'home.flowUse.status.title': '使用情况',
    'home.flowUse.status.used': '已使用',
    'home.flowUse.status.remaining': '剩余',
    'home.flowUse.dataPlan.key': '套餐名称',
    'home.flowUse.validity.key': '有效期',
    'home.flowUse.note.key': '提示',
    'home.flowUse.note': '提示',
    'home.flowUse.leftDay': '剩余{day}{unit}',
    'home.flowUse.currentDataPlan.title': '我的套餐',
    'home.flowUse.currentDataPlan.titleHue': '我的连接服务包',
    'home.flowUse.outDate': '套餐已过期',
    'home.flowUse.lock': 'sim卡已被锁定',
    'home.flowUse.noDataPlan': '还未使用流量',
    'home.flowUse.status.unlimited': '无限量',
    'home.area.intro.title': '流量充值',
    'home.area.intro.titleHue': '充值',
    'home.area.intro.content': '当前套餐能覆盖<cta>欧盟国家</cta>(奥地利，比利时，保加利亚，克罗地亚，塞浦路斯，捷克共和国，丹麦，爱沙尼亚，芬兰，法国，德国，直布罗陀，希腊，匈牙利，爱尔兰，意大利，拉脱维亚，立陶宛，卢森堡，马耳他，荷兰，波兰，葡萄牙，罗马尼亚，斯洛伐克 共和国，斯洛文尼亚，西班牙，瑞典),<cta>同时也包括 冰岛，挪威，瑞士，英国和美国</cta>',
    'home.area.intro.contentHUE': '当前套餐能覆盖<cta>欧盟国家</cta>(奥地利，比利时，保加利亚，克罗地亚，塞浦路斯，捷克共和国，丹麦，爱沙尼亚，芬兰，法国，德国，直布罗陀，希腊，匈牙利，爱尔兰，意大利，拉脱维亚，立陶宛，卢森堡，马耳他，荷兰，波兰，葡萄牙，罗马尼亚，斯洛伐克 共和国，斯洛文尼亚，西班牙，瑞典),<cta>同时也包括 冰岛，挪威，瑞士，英国</cta>请同时启用移动数据和漫游（无需额外漫游费）。',
    'home.area.intro.vatIntro': '价格包含增值税',
    'home.area.intro.suggest': '建议',
    'home.area.switch.title': '地区：',
    'home.active.title': '激活我的套餐',
    'home.active.intro': '“{packageContent}”赠送套餐在首次开机后的90天内激活。 赠送套餐的有效期从激活月份开始，持续{timeLength}',
    'home.active.agree': '激活既同意<a>激活套餐说明</a>，<a1>使用条款</a1> and <a2>隐私协议</a2>. Lenovo Connect由Truphone提供技术支持',
    'home.active.agreeForTablet': '激活既同意<a>激活套餐说明</a>，<a1>使用条款</a1> and <a2>隐私协议</a2>。',
    'home.active.btnText': '立即激活',
    'home.active.failed': '激活失败！',
    'home.active.success': '激活成功',
    'home.active.success.btn': '知道了',
    'home.active.detail.title': '套餐说明',
    'home.active.detail.faq': '如果您有任何疑问, 请查阅<a>客户服务</a>',
}
const suggest = {
    'suggest.title': '建议箱',
    'suggest.toast': '请输入内容',
    'suggest.success': '成功',
    'suggest.suggestions': '请与我们分享您的建议或问题',
    'suggest.submit': '提交',
    'suggest.information': '信息',
    'suggest.submission': '我的提交',
    'suggest.noMore': '没有更多数据',
    'suggest.uploadImg': "图片大小不超过5M",
}
// 我的页面
const me = {
    'me.signOut': '登出',
    'me.nav.device': '我的设备',
    'me.nav.package': '我的套餐',
    'me.nav.order': '我的订单',
    'me.nav.accountInfo': '账号信息',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': '联系我们',
    'me.signOut.alert.title': '登出',
    'me.signOut.alert.content': '确认退出当前账号吗？'
}
// 套餐卡片
const packageCard = {
    'package.validDate': '有效期 {timeLength} {dateUnit}',
    'package.validTo': '有效期至{date} UTC',
    'package.orderBtnText': '立即订购',
    'package.extend.title': '基础套餐',
    'package.expand.title': '扩展套餐',
    'package.extend.titleHue': '订阅每月连接服务包',
    'package.expand.titleHue': '添加额外的连接服务包',
    'package.expand.add': '增加',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': '已经阅读并接受<a>使用说明</a>和<b>隐私策略</b>。',
    'packageDetail.privacyForTablet': '已经阅读并接受<a>使用说明</a>和<b>隐私策略</b>。',
    'packageDetail.description': '套餐说明',
    'packageDetail.expansionPackage.title': '扩展当前套餐',
    'packageDetail.payBtn.text': '立即支付',
}
// 地址
const billAddress = {
    'billAddress.history.title': '历史地址',
    'billAddress.fieldWrap.title': '填写地址信息',
    'billAddress.btn.continue': '继续',
    'billAddress.btn.cancel': '取消',
    'billAddress.field.firstName': '名字',
    'billAddress.field.lastName': '姓',
    'billAddress.field.email': '邮箱',
    'billAddress.field.street': '街道',
    'billAddress.field.city': '城市',
    'billAddress.field.state': '省份',
    'billAddress.tips.payment': '如何支付?',
    'billAddress.tips.newCard': '新卡',
    'billAddress.tips.oldCard': '旧卡',
    'billAddress.field.postCode': '邮编',
    'billAddress.field.country': '国家',
    'billAddress.field.firstNameError': '名字是必填字段',
    'billAddress.field.lastNameError': '姓是必填字段',
    'billAddress.field.emailError': '邮箱是必填字段',
    'billAddress.field.emailFormatError': '邮箱格式错误',
    'billAddress.field.streetError': '街道是必填字段',
    'billAddress.field.cityError': '城市是必填字段',
    'billAddress.field.stateError': '省份是必填字段',
    'billAddress.field.postCodeError': '邮编是必填字段',
    'billAddress.field.countryError': '国家是必填字段',
}
// 订单
const order = {
    'order.subType.1': '激活',
    'order.subType.2': '订购',
    'order.subType.4': '兑换',
    'order.subType.5': '赠品',
    'order.subType.6': '企业订购',
    'order.subType.7': '体验包',
    'order.subType.8': '升级',
    'order.subType.9': '加油包',
    'order.subType.systemOrder': '系统下单',
    'order.item.orderNum': '订单编号',
    'order.item.content': '套餐内容',
    'order.item.orderType': '订单类型',
    'order.item.validity': '有效期',
    'order.item.subTotal': '小计',
    'order.item.vat': '税',
    'order.item.totalFee': '总价',
    'order.noInfo.message': '你还没有订购套餐！',
    'order.noInfo.btnText': '去首页'
}
// 支付结果页
const payResult = {
    'pay.success': '支付成功',
    'pay.fail': '支付失败',
    'pay.checkOrder': '查看订单',
    'pay.back': '返回',
    'pay.continue': '继续订购',
}
// 我的设备页面
const device = {
    'device.switch': '切换设备',
    'device.status.current': '当前设备',
    'device.status.available': '可用设备',
    'device.switch.alert.title': '提示',
    'device.switch.alert.content': '确认切换至该设备吗？',
    'device.noInfo.message': '你还未绑定设备',
    'device.noInfo.btnText': '前往绑定设备',
    'device.edit.prompt.message': '请输入昵称',
    'device.edit.check.none': '昵称不能为空',
}
// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': '可用套餐',
    'myDataPlan.tabbar.expired': '过期套餐',
    'myDataPlan.noAvailablePlan': '暂无可用套餐',
    'myDataPlan.noExpiredPlan': '暂无过期套餐',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': '昵称长度在4-20位之间',
    'account.account.fieldTitle': '账号',
    'account.nickName.fieldTitle': '昵称',
    'account.nickName.character': '4-20个字符, 包括中英文, 数字和 "-"',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'SIM卡支持打电话、发短信吗？',
    'faq.question.2': '如何订购套餐及查询订购记录？',
    'faq.question.3': '套餐订购规则是什么？',
    'faq.question.4': '支付方式有什么？',
    'faq.question.5': '不想使用流量需要怎么关闭？',
    'faq.question.6': '套餐已激活/订购成功，但是无法使用？',
    'faq.question.7': '无法上网，如何处理？',
    'faq.question.8': '现在有哪些国家可以使用？',
    'faq.question.9': '客服联系方式？',
    'faq.question.10': '发票怎么申请？',
    'faq.question.11': '如需补换SIM卡，怎么操作？',
    'faq.question.12': '补换SIM卡需要付费吗？',
    'faq.question.13': '如果我的SIM卡丢失、损坏或出现故障，我可以暂停激活的数据计划吗？',
    'faq.question.14': '如果我忘了密码怎么办？',
    'faq.question.15': '我的SIM卡的ICCID和我的联想ID绑定后可以更改吗？',
    'faq.question.16': '如果设备要求我输入PIN、PIN 2或PUK代码，或输入APN，我该怎么办？',
    'faq.question.17': '如何检查SIM卡的ICCID？',
    'faq.question.18': 'CONTACT US',
    'faq.answer.1': 'The SIM only supports data for network access. You will not receive a mobile number. You can still make calls or send SMS using Apps like Skype, Whatsapp.',
    'faq.answer.2': 'Please visit aoacwap.lenovoconnect.com to proceed.',
    'faq.answer.3': 'Connectivity Service Package ordered successfully will be automatically activated (e.g. Expand My Data Plan) or will wait in queue to be activated (e.g. Extend My Data Plan). We do not support data plan refund or suspension. ',
    'faq.answer.4': 'We sell plans in GBP, EUR, USD,CHF, NOK, DKK, SEK and support Credit/Debit Visa or Master cards.',
    'faq.answer.5': 'If you want to stop using cellular connectivity, please click OFF the "Mobile data"      . Please be noted that your ongoing data plan will NOT be suspended or refunded. ',
    'faq.answer.6.1': '1) If the ordered plan is to extend your current plan, it can only be activated once your current plan expires. ',
    'faq.answer.6.2': '2) If the ordered plan is to expand your current plan, it should be activated automatically. Please refer to other FAQ for connectivity issue, or contact Lenovo.com Customer Service in your own country.',
    'faq.answer.6.3': '3) If you have multiple devices under the same Lenovo ID, please ensure the ordered data plan is under the ICCID of the current used device\'s SIM. ',
    'faq.answer.7.1': '1) Check if "Mobile data" is switched ON.',
    'faq.answer.7.2': '2) Check if "Data roaming" is enabled. Go to Settings->Network&Internet->Mobile network->Data roaming',
    'faq.answer.7.3': '3) Check if Access Point Name (APN) is correctly set up.Go to Settings->Network&Internet->Mobile network->Advanced->Access point names-> add APN: net.truphone.com',
    'faq.answer.7.4': '4) If this is your first connection, it might take a few minutes for the SIM to connect. ',
    'faq.answer.7.5': '5) Please ensure the preload data plan is activated; if not, please follow the instructions in the SIM package to activate. ',
    'faq.answer.7.6': '6) Make sure your current location is within our service coverage scope (See full list of covered countries below) Move your device beside a window or an open area in order to receive a better signal. ',
    'faq.answer.8': 'The data plan can cover all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, United Kingdom and United States of America.',
    'faq.answer.8.1': 'The data plan can cover all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, United Kingdom.',
    'faq.answer.9': 'Please refer to below Customer Service information of Lenovo.com in your own country.',
    'faq.answer.10': 'The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it.  If still not received, please contact Lenovo Customer Service.',
    'faq.answer.11': 'If your SIM is broken, lost or faulty, please contact Lenovo Customer Service for a solution.',
    'faq.answer.12': 'Yes, but courier service charge may apply. Please contact Lenovo Customer Service for details.',
    'faq.answer.13': 'Sorry, the data plan cannot be suspended.',
    'faq.answer.14': 'You can re-set your password via " Forgot password " on the Sign in page',
    'faq.answer.15': 'Yes. Please contact Lenovo Customer Service for such request. After verification, Customer Service staff will help remove the current binding between the SIM\'s ICCID and your Lenovo ID. Note that connectivity service package within validities cannot be suspended or unsubscribed regardless of the SIM-Lenovo ID binding status.',
    'faq.answer.16': 'Try deactivating and reactivating Cellular and also restarting the device. If this does not help, please contact our Customer Service.',
    'faq.answer.17.1': '1) You can find the ICCID on the SIM chip or the SIM holder.',
    'faq.answer.17.2': '2) If you have activated the SIM and preload data plan, please visit aoacwap.lenovoconnect.com and check "Me"->"Device"',
    'faq.answer.18': 'Please refer to Customer Service information on Lenovo website in your country.',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': '选择地区',
    'contact.country.AT': 'Austria',
    'contact.country.BE': 'Belgium',
    'contact.country.DK': 'Denmark',
    'contact.country.FI': 'Finland',
    'contact.country.FR': 'France',
    'contact.country.DE': 'Germany',
    'contact.country.IE': 'Ireland',
    'contact.country.IT': 'Italy',
    'contact.country.LUX': 'Luxembourg',
    'contact.country.NL': 'Netherlands',
    'contact.country.NO': 'Norway',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'Spain',
    'contact.country.SE': 'Sweden',
    'contact.country.CH': 'Switzerland',
    'contact.country.UK': 'United Kingdom',
    'contact.country.USA': 'USA',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (lokaal tarief)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Calls to this number are charged at local rate from a landline and have a minimum cost of €0.05. Calls from mobiles may vary.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (National Rate)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.BE': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.DK': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.FI': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8 - 18 Uhr Montag - Freitag',
    'contact.workHours.IE': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.IT': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.LUX': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.NL': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.NO': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.PT': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.ES': 'de 8:00h a 18:00h, de lunes a viernes',
    'contact.workHours.SE': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.CH': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.UK': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.USA': '00:00 - 24:00 Monday - Sunday',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': '你好',
    'bindSim.activate.title': '激活你的流量套餐',
    'bindSim.tip.text1': '上传条形码图片来绑定sim卡',
    'bindSim.tip.text2': '激活套餐并使用',
    'bindSim.btn.text': '上传图片',
}
//平板faq
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'Q1：如果以下均不能解答问题，如何联系客服？',
    'faq.answer.1': 'A1：请联系官方网站客服信息，或直接邮件至service@lenovoconnect.com。邮件中请注明卡的ICCID。',
    'faq.question.2': 'Q2：SIM卡支持打电话、发短信吗？',
    'faq.answer.2': 'A2:：SIM卡仅支持数据流量上网功能，不支持语音、短信功能。',
    'faq.question.3': 'Q3: 卡能换到其他设备使用吗？',
    'faq.answer.3': 'A3: 仅支持插入当前设备（平板）内使用，暂不支持其他设备使用。',
    'faq.question.4': 'Q4：套餐支持在哪些国家使用？不同国家有漫游费用吗？',
    'faq.answer.4': 'A4: 套餐可使用国家包括所有欧盟国家及冰岛，挪威，瑞士和英国。在这些国家范围内没有额外的漫游费用。',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'Q1：如何订购套餐及查询订购记录？套餐流量没有用完可以累计到次月吗？',
    'faq.answer.5': 'A1：请访问平板桌面上预装的APP "Len"。或访问链接aoacwap.lenovoconnect.com进行查询订购的流量套餐。当前套餐未使用完无法累计到次月。',
    'faq.question.6': 'Q2：赠送的套餐从什么时间开始计算？',
    'faq.answer.6': 'A2：从您在APP "Len" 注册登录后，点击首页套餐激活后开始计算。',
    'faq.question.7': 'Q3：套餐订购规则是什么？',
    'faq.answer.7': 'A3：如果您订购的是新套餐，将会自动激活。如果您订购的是超额包，将在当前流量用尽后激活。套餐不支持退订或暂停。',
    'faq.question.8': 'Q4：支付方式有什么？',
    'faq.answer.8': 'A4：支持Visa卡或Master卡支付（英镑，欧元，美金，瑞士法郎，挪威克朗，丹麦克朗，瑞典克朗）',
    'faq.question.9': "Q5: 套餐已激活/订购成功，但是无法使用？",
    'faq.answer.9': 'A5: 如果您订购的是超额包套餐，会在您现有套餐用尽后激活。如果您订购的是月套餐，套餐会自动激活。可在我的订单中查询状态。如果非以上问题，请联系联想客服团队或直接联系邮箱: service@lenovoconnect.com',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'Q1：APP "Len" 被误删了或没有找到怎么办？',
    'faq.answer.10': `A1：请通过以下链接https://aoacupg.lenovoconnect.com/common/downloadLatest重新下载。`,
    'faq.question.11': "Q2：无法登录APP，怎么办？",
    'faq.answer.11.1': 'A2：1. APP第一次登录可能会花费时间较长，可等待半分钟左右。',
    'faq.answer.11.2': '2. 可尝试完全退出APP后重新进入。',
    'faq.answer.11.3': '3. APP注册页面显示：邮箱已存在。请使用您的Lenovo ID直接登录，或使用新的邮箱地址重新注册。',
    'faq.answer.11.4': '4. APP登录页面显示，号卡已经绑定。此种情况为您已经将此卡绑定过某邮箱账号。如需解绑并重设邮箱，请邮件至service@lenovoconnect.com',
    'faq.question.12': 'Q3：如果我忘了注册邮箱的密码怎么办？',
    'faq.answer.12': 'A3：您可以在APP Len的登录页面下方点击"Forgot password" 进行重设密码。',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "Q1：不想使用流量需要怎么关闭？",
    'faq.answer.13': 'A1：如果您想关闭流量上网服务，请在Settings-Network&Internet中关闭"Mobile data" 。"Mobile data" 关闭后套餐不会暂停或退订。',
    'faq.question.14': 'Q2：无法上网，如何处理？',
    'faq.answer.14.1': 'A2：1. 请检查Settings-Network&Internet-Mobile data开关打开',
    'faq.answer.14.2': '2. 请检查Settings-Network&Internet-Data roaming开关打开（需打开，不会产生额外漫游费用）',
    'faq.answer.14.3': '3. 检查Settings-Network&Internet-Advanced-Access Point Names是否设置正确，应设置为：lenovo.m2m.drei.at. 如没有该APN，请手动写入。',
    'faq.answer.14.4': '4. 如果这是您第一次连接，可能需要几分钟的连接时间。',
    'faq.answer.14.5': '5. 请登录APP Len后，确认赠送的流量套餐已点击激活。如未激活，请登录APP点击主页面的激活。',
    'faq.answer.14.6': '6. 请确认您所在地区属于服务范围内（详细范围请参照下列国家）。可移动到较开阔的地方接收信号。(Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden, plus Iceland, Norway, Switzerland, and United Kingdom).',
    'faq.answer.14.7': '7. 请检查SIM卡是否安装无误，并重启设备。',
    'faq.answer.14.8': '8. 请查看Settings-Network&Internet-Automatically select network, 可手动切换/选择其中的网络。如发现某网络后显示“forbidden", 请手动点击后清除“forbidden”。如果网络无法点击，请将SIM卡换到手机上，重复相同动作（找到移动流量--网络，手动清除网络的forbidden)。',
    'faq.question.15': "Q3：如何检查SIM卡的ICCID？",
    'faq.answer.15.1': 'A3：1. 请拔出插在平板内的SIM卡，卡片上面有ICCID。',
    'faq.answer.15.2': '2. 请在APP Len-Me-Device中查看.',
    'faq.answer.15.3': '3. 可访问aoacwap.lenovoconnect.com，将在页面上看到您的ICCID。',
    'faq.question.16': 'Q4：发票怎么申请？',
    'faq.answer.16.1': 'A4：发票会在您订购套餐成功后自动发送到您注册的邮箱地址。请检查收件箱和垃圾信箱。如仍未收到，请联系客服或邮件至service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "Q1：我的SIM卡的ICCID和我的联想ID绑定后可以更改吗？",
    'faq.answer.17': 'A1：可以的。请联系联想客服中心或邮件至service@lenovoconnect.com申请解绑。请注意有效期内的订购套餐不会因解绑而暂停。',
    'faq.question.18': 'Q2：设备里没有卡、卡面有明显损坏、卡丢失了怎么办？可以暂停激活的套餐吗？',
    'faq.answer.18': 'A2：如果您的SIM卡破损或丢失，请联系联想客服中心或联系邮箱service@lenovoconnect.com 核实具体情况后可为您补寄。已激活的套餐不支持暂停或退订。',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': '密码错误',
    'iCode.i0002': '用户名已存在',
    'iCode.i0003': '密码格式错误',
    'iCode.i0004': '帐号必须激活后才能登录。',
    'iCode.i0005': '账号已被禁用',
    'iCode.i0006': '登录超时',
    'iCode.i0007': '错误',
    'iCode.i0008': '账号或密码错误',
    'iCode.i0009': '请输入五位图片验证码',
    'iCode.i0010': '操作过于频繁， 请稍后再试',
    'iCode.i0011': '无效的回调地址。',
    'iCode.i0012': '无效的签名。',
    'iCode.i0013': '请刷新验证码',
    'iCode.i0014': '服务端错误。',
    'iCode.i0015': 'serviceGoodsId为空',
    'iCode.i0016': '消息发送成功',
    'iCode.i0017': '消息发送失败',
    'iCode.i0018': '兑换码错误',
    'iCode.i0019': '请在兑换期内使用',
    'iCode.i0020': '兑换码已过期',
    'iCode.i0021': '兑换码已使用',
    'iCode.i0022': '兑换码已失效',
    'iCode.i0023': '生成订单中， 请稍后...',
    'iCode.i0024': '操作失败',
    'iCode.i0025': '号卡不满足兑换条件',
    'iCode.i0026': '二维码生成失败',
    'iCode.i0027': '创建升级订单信息有误',
    'iCode.i0028': '卡不存在',
    'iCode.i0029': '手机号格式错误',
    'iCode.i0030': '短信发送太频繁',
    'iCode.i0031': '参数错误',
    'iCode.i0032': '当日验证码发送次数已到上限',
    'iCode.i0033': '注册成功',
    'iCode.i0034': '注册失败',
    'iCode.i0035': '请先绑定号卡',
    'iCode.i0036': '请先登录账号',
    'iCode.i0037': '更新状态失败',
    'iCode.i0038': '启用中， 请稍后',
    'iCode.i0039': 'orderId为空',
    'iCode.i0040': '激活中， 请稍后',
    'iCode.i0041': '套餐已下架',
    'iCode.i0042': '激活操作失败!',
    'iCode.i0043': '激活操作成功!',
    'iCode.i0044': '系统识别不到该号卡',
    'iCode.i0045': '套餐已激活， 请勿重复操作',
    'iCode.i0046': '没有激活套餐',
    'iCode.i0047': '卡已停用',
    'iCode.i0048': '套餐信息不正确',
    'iCode.i0049': '用户或密码为空',
    'iCode.i0050': '当月无基础套餐',
    'iCode.i0051': '登录成功',
    'iCode.i0052': '登录失败',
    'iCode.i0053': '设备为空',
    'iCode.i0054': '验证码错误请重新输入',
    'iCode.i0055': '操作成功',
    'iCode.i0056': '号卡为空',
    'iCode.i0057': '获取token失败',
    'iCode.i0058': '企业编码不存在',
    'iCode.i0059': '卡的用途跟企业的企业属性不一致',
    'iCode.i0060': '请勿频繁操作',
    'iCode.i0061': '领取优惠券成功',
    'iCode.i0062': '不满足领取条件',
    'iCode.i0063': '领取优惠券出错',
    'iCode.i0064': 'iccid绑定失败',
    'iCode.i0065': 'iccid已经绑定',
    'iCode.i0066': '绑定成功',
    'iCode.i0067': '绑卡异常',
    'iCode.i0068': 'simId为空',
    'iCode.i0069': 'esimId为空',
    'iCode.i0070': '没有绑卡',
    'iCode.i0071': '用户不存在',
    'iCode.i0072': '昵称不能为空',
    'iCode.i0073': '更新成功',
    'iCode.i0074': '更新失败',
    'iCode.i0075': '首页无号卡查询套餐异常',
    'iCode.i0076': '相关信息不存在',
    'iCode.i0077': '生成加密签名失败。',
    'iCode.i0078': '切换失败',
    'iCode.i0079': '切换成功',
    'iCode.i0080': '请勿重复提交申请！',
    'iCode.i0081': '请刷新后重新操作！',
    'iCode.i0082': '获取首页banner图失败',
    'iCode.i0083': '当前无绑定iccid卡号， 无优惠套餐',
    'iCode.i0084': '当前无绑定iccid卡号， 无可用套餐',
    'iCode.i0085': '认证成功',
    'iCode.i0086': '认证失败',
    'iCode.i0087': '系统异常',
    'iCode.i0088': '卡已实名',
    'iCode.i0089': '订购套餐操作成功',
    'iCode.i0090': '订购套餐操作失败',
    'iCode.i0091': '服务商品不存在',
    'iCode.i0092': '升级服务订单生成完毕',
    'iCode.i0093': '无升级套餐服务',
    'iCode.i0094': '未查询到对应订单',
    'iCode.i0095': '当前套餐未支付',
    'iCode.i0096': '订单中套餐Id为空',
    'iCode.i0097': '套餐已启用',
    'iCode.i0098': '订购成功',
    'iCode.i0099': '暂无码号可用',
    'iCode.i0100': '无该地区码号',
    'iCode.i0104': '无法获取号卡所属子地区',
    'iCode.i0109': '读取条形码失败，请重试',
}
export default {
    ...common,
    ...language,
    ...login,
    ...home,
    ...packageDetail,
    ...register,
    ...packageCard,
    ...billAddress,
    ...me,
    ...accountInfo,
    ...order,
    ...device,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': '首页',
    'tab.text.me': '我的'
}
